module.exports = __webpack_public_path__ + "img/sandefjord.8fbf9dd8.jpeg";